import { WarningOutlined } from "@ant-design/icons";
import { Button, Dialog } from "antd-mobile";
import style from "css/hotdesking.module.css";
import React from "react";

function Error({ message }) {
  const onClose = () => {
    Dialog.clear();
  };
  return (
    <section className={style.confirm_content}>
      <article className={style.content_article}>
        <WarningOutlined
          className={style.content_icon}
          style={{ color: "#ef8a17" }}
        />
        <p>{message}</p>
      </article>
      <section className={style.content_footer}>
        <Button className={style.submit_button} onClick={onClose}>
          확인
        </Button>
      </section>
    </section>
  );
}

export default Error;
